import { useEffect, useRef } from "react";
import { subscribeMesfRealtimeTopic } from "../services/mesfRealtimeConnection";

type Props = {
	/** Stored procedure names (brackets optional), e.g. ["M2.GetHeats"]. */
	topics: string[];
	onMessage: (topic: string) => void;
};

/**
 * Runs `onMessage` when the server reports one of `topics` as stale, over the single shared
 * connection. To refresh a query, put `meta: { realtime: [...] }` on it instead.
 */
export const useMesfRealtime = ({ topics, onMessage }: Props) => {
	const onMessageRef = useRef(onMessage);
	onMessageRef.current = onMessage;

	const topicsKey = topics.join("\n");

	useEffect(() => {
		const unsubscribes = topicsKey
			.split("\n")
			.filter(Boolean)
			.map((topic) =>
				subscribeMesfRealtimeTopic(topic, (t) => onMessageRef.current(t)),
			);
		return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
	}, [topicsKey]);
};
